import {createAction} from 'redux-actions'

export const update = createAction('INSTALLERS/STORE/UPDATE', data => Array.isArray(data) ? data : [data])
export const clear = createAction('INSTALLERS/STORE/CLEAR')
export const purge = createAction('INSTALLERS/STORE/PURGE')

export const accept = createAction('INSTALLERS/STORE/ACCEPT', data => Array.isArray(data) ? data : [data])
export const reject = createAction('INSTALLERS/STORE/REJECT', data => Array.isArray(data) ? data : [data])
export const revert = createAction('INSTALLERS/STORE/REVERT', data => Array.isArray(data) ? data : [data])